import { ProductAttribute, ProductAttributeInfo } from '@@partner:types:app'
import AppLoader from '@components/common/AppLoader'
import React from 'react'
import { Row, Table, Tag } from 'rsuite'


type AttributesTableProps = {
  attributes?: ProductAttributeInfo[]
  loadingProduct: boolean
}

export default function AttributesTable ({
  attributes,
  loadingProduct
}: AttributesTableProps) {
  


  return (
    <Row>
      <Table
        data={attributes}
        rowHeight={60}
        autoHeight
        loading={loadingProduct}
        renderLoading={() =>
          loadingProduct ? <AppLoader.Inner content="Загрузка таблицы" /> : null
        }
        affixHeader
        rowKey={'id'}
      >
        <Table.Column width={200}>
          <Table.HeaderCell>Атрибут</Table.HeaderCell>
          <Table.Cell>
            {(rowData: { id: string; attribute: ProductAttribute; value: string }) => (
              <div>
                <strong>{rowData.attribute.name}</strong>
                {rowData.attribute.is_filterable && (
                  <Tag color="blue" size="sm" style={{ marginLeft: 8 }}>
                    Фильтр
                  </Tag>
                )}
              </div>
            )}
          </Table.Cell>
        </Table.Column>
        <Table.Column flexGrow={1}>
          <Table.HeaderCell>Значение</Table.HeaderCell>
          <Table.Cell>
            {(rowData: { id: string; attribute: ProductAttribute; value: string }) => (
              <div>
                {rowData.attribute.prefix && <span>{rowData.attribute.prefix} </span>}
                {(() => {
                  const { value_type } = rowData.attribute
                  const value = rowData.value
                  
                  switch (value_type) {
                  case 'boolean':
                    return value === 'true' ? 'Да' : 'Нет'
                  case 'list':
                    return value.split(',').join(', ')
                  default:
                    return value
                  }
                })()}
                {rowData.attribute.postfix && <span> {rowData.attribute.postfix}</span>}
              </div>
            )}
          </Table.Cell>
        </Table.Column>
        <Table.Column width={120}>
          <Table.HeaderCell>Тип</Table.HeaderCell>
          <Table.Cell>
            {(rowData: { id: string; attribute: ProductAttribute; value: string }) => {
              const typeLabels = {
                string: 'Строка',
                int: 'Число',
                float: 'Дробное',
                decimal: 'Дробное',
                boolean: 'Да/Нет',
                list: 'Список'
              }
              return typeLabels[rowData.attribute.value_type] || rowData.attribute.value_type
            }}
          </Table.Cell>
        </Table.Column>

      </Table>
    </Row>
  )
}